import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { SelectItem } from "primeng/api";
import { SelectButton } from "primeng/selectbutton";

import { FeatureBadgeComponent } from "../../ui/feature-badge/feature-badge.component";

export const quoteListTab = {
  quotes: "list",
  requests: "requests",
} as const;

@Component({
  selector: "app-quote-list-tabs",
  templateUrl: "./quote-list-tabs.component.html",
  styleUrls: ["./quote-list-tabs.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectButton, FormsModule, FeatureBadgeComponent],
})
export class QuoteListTabsComponent {
  private router = inject(Router);

  readonly active = input<string>(quoteListTab.quotes);

  public readonly tabs: SelectItem[] = [
    { label: "Quotes list", value: quoteListTab.quotes, icon: "pi pi-list" },
    {
      label: "Requests",
      value: quoteListTab.requests,
      icon: "pi pi-envelope",
    },
  ];

  // Tab marked with a "New" badge.
  public readonly newTab = quoteListTab.requests;

  public onTabChange(tab: string): void {
    this.router.navigate(["/quote", tab]);
  }
}
